const AnnualPlan = () => {
  const isMobile = window.innerWidth <= 600;

  const formatNumber = (value) => {
    if (typeof value !== 'string' && typeof value !== 'number') {
      return value;
    }

    const raw = String(value);
    if (!/^\d+$/.test(raw)) {
      return value;
    }

    const numericValue = Number(raw);
    if (numericValue < 1000) {
      return value;
    }

    return numericValue.toLocaleString('en-US');
  };
  
  const styles = {
    container: {
      padding: '1rem',
      maxWidth: '100%',
      margin: '0 auto',
      overflow: 'hidden'
    },
    header: {
      textAlign: 'center',
      marginBottom: '1rem',
      fontSize: isMobile ? '1.25rem' : '1.5rem'
    },
    subHeader: {
      textAlign: 'center',
      marginBottom: '1rem',
      fontSize: isMobile ? '1rem' : '1.25rem'
    },
    tableContainer: {
      overflowX: 'auto'
    },
    responsiveTable: {
      borderCollapse: 'collapse',
      width: '100%',
      fontSize: isMobile ? '0.6rem' : '0.75rem'
    },
    tableCell: {
      padding: isMobile ? '0.3rem' : '0.5rem',
      textAlign: 'left',
      wordWrap: 'break-word',
      fontSize: isMobile ? '0.6rem' : '0.75rem'
    },
    tableHeader: {
      padding: isMobile ? '0.3rem' : '0.5rem',
      textAlign: 'left',
      fontWeight: 'bold',
      fontSize: isMobile ? '0.6rem' : '0.75rem'
    }
  };

  const TableCell = ({ children, colSpan }) => (
    <td 
      style={styles.tableCell} 
      className="border border-primary"
      colSpan={colSpan}
    >
      {children}
    </td>
  );

  const TableHeader = ({ children }) => (
    <th style={styles.tableHeader} className="border border-primary">
      {children}
    </th>
  );

  const headerData = [
    "S.No.",
    "Name of Main-Course/Sector",
    "Sub Course",
    "Duration (In Hours)",
    "No of Session per batch",
    "No of Batches",
    "No of Beneficiaries per batch",
    "Total no. of Beneficiaries",
    "Honorarium per session (INR)",
    "Honorarium per batch (INR)",
    "Total Honorarium (INR)",
    "Cost of TLM per batch (INR)",
    "Total TLM Cost (INR)",
    "Cost of Training per batch (INR)",
    "Total Cost of the Program (INR)",
    "Cost per Trainee (INR)"
];

const tableData = [
    ["1", "Handicrafts & Carpets", "Assistant Hand Embroiderer", "240", "80", "4", "20", "80", "320", "25600", "102400", "7000", "28000", "32600", "130400", "1630"],
    ["2", "Apparel, Made ups & Home Furnishing", "Assistant Dress Maker", "240", "80", "5", "20", "100", "320", "25600", "128000", "7500", "37500", "33100", "165500", "1655"],
    ["3", "Apparel, Made ups & Home Furnishing", "Darzi (Advance)", "120", "40", "4", "20", "80", "320", "12800", "51200", "7000", "28000", "19800", "79200", "990"],
    ["4", "Beauty & Wellness", "Beauty Care Assistant", "240", "80", "5", "20", "100", "320", "25600", "128000", "7500", "37500", "33100", "165500", "1655"],
    ["5", "Beauty & Wellness", "Assistant Hair Dresser Saloon Services (Advance)", "120", "40", "5", "20", "100", "320", "12800", "64000", "7000", "35000", "19800", "99000", "990"],
    ["6", "IT-ITES", "Data Analysis Assistant", "300", "100", "1", "20", "20", "320", "32000", "32000", "6000", "6000", "38000", "38000", "1900"],
    ["7", "IT-ITES", "Course on Computer Concept", "90", "30", "2", "20", "40", "320", "9600", "19200", "4000", "8000", "13600", "27200", "680"],
    ["8", "Tourism and Hospitality", "Laghu Udhaymi (Fast Food Stall)", "90", "30", "2", "20", "40", "320", "9600", "19200", "5000", "10000", "14600", "29200", "730"],
    ["9", "Food Processing", "Basic of Papar, Pickles and Masala Powder Making", "150", "50", "2", "20", "40", "350", "17500", "35000", "6500", "13000", "24000", "48000", "1200"],
    ["10", "Capital Goods & Manufacturing", "Assistant Welder & Fabricator", "240", "80", "1", "20", "20", "350", "28000", "28000", "4500", "4500", "32500", "32500", "1625"],
    ["11", "Agriculture", "Vermi Compost Producer", "270", "90", "3", "20", "60", "250", "22500", "67500", "4000", "12000", "26500", "79500", "1325"],
    ["12", "Handicrafts & Carpets", "Essentials of Paper Cover Envelope and File Making", "90", "30", "3", "20", "60", "350", "10500", "31500", "4000", "12000", "14500", "43500", "725"],
    ["13", "Healthcare", "Yoga Training Assistants", "270", "90", "3", "20", "60", "350", "31500", "94500", "4500", "13500", "36000", "108000", "1800"],
    ["14", "Healthcare", "Basic Health & Wellness Skills (Sec. School)", "60", "20", "2", "20", "40", "320", "6400", "12800", "4000", "8000", "10400", "20800", "520"],
    ["15", "Healthcare", "Basic Health & Wellness Skills (Sen. Sec.)", "90", "30", "2", "20", "40", "320", "9600", "19200", "4000", "8000", "13600", "27200", "680"],
    ["16", "Handicrafts & Carpets", "Assistant Jute Craft Product Maker", "240", "80", "1", "20", "20", "350", "28000", "28000", "6500", "6500", "34500", "34500", "1725"],
    ["Total", "", "", "", "", "45", "", "900", "", "307600", "860500", "", "267500", "396600", "1128000", "19830"],
    ["", "", "", "", "", "", { text: "Budget for Skill Training Program", colSpan: 8 }, "1128000", ""],
    ["", "", "", "", "", "", { text: "Budget for Capacity Building program with RP and JSS Staff", colSpan: 8 }, "36000 (3%)", ""],
    ["", "", "", "", "", "", { text: "Budget for Activity", colSpan: 8 }, "36000 (3%)", ""],
    ["", "", "", "", "", "", "", "", "", "", "", "", "Grand Total", "", "1200000", ""]
];

  return (
    <div style={styles.container}>
      <h1 style={styles.header} className="font-bold text-tertiary">JAN SHIKSHAN SANSTHAN, BIKANER (RAJ)</h1>
      <h2 style={styles.subHeader} className="text-tertiary font-semibold">ANNUAL ACTION PLAN 2026-27 AAP PART A</h2>

      <div style={styles.tableContainer}>
        <table style={styles.responsiveTable} className="bg-primary-light border-collapse border border-primary rounded-sm">
          <thead>
            <tr className="bg-primary-dark text-background">
              {headerData.map((header, index) => (
                <TableHeader key={index}>{header}</TableHeader>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                {row.map((cell, cellIndex) => {
                  if (typeof cell === 'object' && cell.text && cell.colSpan) {
                    return (
                      <TableCell key={cellIndex} colSpan={cell.colSpan}>
                        {cell.text}
                      </TableCell>
                    );
                  }
                  const formattedCell = formatNumber(cell);
                  return (
                    <TableCell key={cellIndex}>{formattedCell}</TableCell>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnnualPlan;
